<template>
  <div class="search-container">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h1>Trouvez le travail qui correspond à votre vie</h1>
          <br />
          <h2>
            Plus de <strong>{{ jobOffersCount }}</strong> emplois vous attendent
            pour lancer votre carrière
          </h2>
          <div class="content">
            <form method="" action="">
              <div class="row" style="background: rgba(255, 255, 255, 0.1)">
                <div class="col-md-5 col-sm-12 offset-md-1">
                  <v-combobox
                    light
                    v-model="jobBoardJobModel"
                    :items="items"
                    :loading="isLoading"
                    :search-input.sync="search"
                    prepend-inner-icon="mdi-electron-framework"
                    chips
                    small-chips
                    clearable
                    hide-details
                    hide-selected
                    item-text="name"
                    item-value="symbol"
                    label="Métier, mots clés ou entreprise"
                    solo
                    multiple
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          Entrer un métier, mots clés ou entreprise pour
                          rechercher
                          <strong>des offres</strong>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.name"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-combobox>
                </div>
                <div class="col-md-5 col-sm-12">
                  <v-combobox
                    light
                    v-model="where"
                    :items="locationItems"
                    :loading="locationIsLoading"
                    :search-input.sync="locationSearch"
                    prepend-inner-icon="mdi-map-marker-radius-outline"
                    chips
                    clearable
                    hide-details
                    hide-selected
                    item-text="name"
                    item-value="symbol"
                    label="Où"
                    v-on:keyup="locationFieldKeyUpListerner"
                    solo
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          Entrer une ville, une commune, une préfecture, etc...
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.name"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-combobox>
                </div>
                <div class="col-md-1 col-sm-12">
                  <button
                    type="button"
                    class="btn btn-search-icon"
                    v-on:click="searchJob"
                  >
                    <i class="ti-search"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HttpClient from "@/services/HttpClient/HttpClient";
import { timeSince } from "@/helper/DateTimeHelper";

export default {
  name: "SearchJobForm",
  data: function () {
    return {
      isLoading: false,
      items: [],
      jobOffersCount: 0,
      locationItems: [],
      jobBoardJobModel: null,
      where: null,
      search: null,
      locationSearch: null,
      tab: null,
      locationTab: null,
      locationIsLoading: false,
    };
  },
  watch: {
    jobBoardJobModel(val) {
      if (val != null) this.tab = 0;
      else this.tab = null;

      // if (val.length > 0) {
      //   this.searchJob();
      // }
    },
    search(val) {
      // Items have already been loaded
      if (this.items.length > 0 && val) {
        const result = this.items.filter(
          (value) =>
            value.name.toLowerCase() === val.toLowerCase() ||
            value.name.toLowerCase().search(val.toLowerCase()) !== -1
        );
        if (result.length > 0) {
          return;
        }
      }
      this.isLoading = true;
      const httpClient = new HttpClient();
      httpClient
        .fetchCompanyKeyWordsJobTitleAndActivitySectorForPublicUser(val)
        .then((res) => {
          this.items = res.data;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.push("/logout");
          } else {
            alert("Une erreur s'est produite");
          }
        })
        .finally(() => (this.isLoading = false));
    },
    where(val) {
      if (val != null) this.locationTab = 0;
      else this.locationTab = null;

      // if (typeof val === "object") {
      //   this.searchJob();
      // } else if (typeof val === "string" && val.trim() !== "") {
      //   this.searchJob();
      // }
    },
    locationSearch(val) {
      // Items have already been loaded
      if (this.locationItems.length > 0 && val) {
        const result = this.locationItems.filter(
          (value) =>
            value.name.toLowerCase() === val.toLowerCase() ||
            value.name.toLowerCase().search(val.toLowerCase()) !== -1
        );
        if (result.length > 0) {
          return;
        }
      }
      this.locationIsLoading = true;
      const httpClient = new HttpClient();
      httpClient
        .fetchLocations(val, localStorage.getItem("jwt-token"))
        .then((res) => {
          res.data.forEach((elt) => {
            this.locationItems.push({
              name: elt.jobLocation,
            });
          });
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.push("/logout");
          } else {
            alert("Une erreur s'est produite");
          }
        })
        .finally(() => (this.locationIsLoading = false));
    },
  },
  methods: {
    checkForm: function () {
      this.formErrors = [];
      let isValid = true;

      if (this.jobBoardJobModel === null && this.where === null) {
        isValid = false;
        this.formErrors = [];
        this.formErrors.push("Complétez les informations.");
      }
      // } else if (this.jobBoardJobModel.length === 0) {
      //   isValid = false;
      //   this.formErrors = [];
      //   this.formErrors.push("Complétez les informations.");
      // }
      //
      // if (this.where === null) {
      //   isValid = false;
      //   this.formErrors = [];
      //   this.formErrors.push("Complétez les informations.");
      // } else if (
      //   typeof this.where !== "object" &&
      //   typeof this.where !== "string"
      // ) {
      //   isValid = false;
      //   this.formErrors = [];
      //   this.formErrors.push("Complétez les informations.");
      // } else if (typeof this.where == "string" && this.where.trim() === "") {
      //   isValid = false;
      //   this.formErrors = [];
      //   this.formErrors.push("Complétez les informations.");
      // }

      return isValid;
    },
    searchJob: function () {
      // alert('he');
      if (this.checkForm()) {
        let searchContent = [];
        let jobLocation = "";
        if (
          this.jobBoardJobModel !== null &&
          this.jobBoardJobModel.length > 0
        ) {
          // console.log("jobBoardJobModel", this.jobBoardJobModel)
          this.jobBoardJobModel.forEach((elt) => {
            if (typeof elt === "object") {
              searchContent.push(elt.name);
            } else {
              searchContent.push(elt);
            }
          });
        }

        if (this.where !== null) {
          if (typeof this.where === "object") {
            jobLocation = this.where.name;
          } else {
            jobLocation = this.where;
          }
        }

        this.$router.push({
          name: "PublicUserViewOffers",
          query: {
            what: searchContent,
            where: jobLocation,
          },
        });
      }
    },
    locationFieldKeyUpListerner: function (event) {
      event.preventDefault();
      if (event.keyCode === 13) {
        this.searchJob();
      }
    },
    getJobOffersCount: function () {
      const httpService = new HttpClient();
      httpService.getItemsCount().then((res) => {
        this.jobOffersCount = parseInt(res.data.jobOffersCount, 10);
      });
    },
  },
  mounted() {
    this.getJobOffersCount();
  },
};
</script>

<style scoped></style>
